// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionDropdownController from "./accordion_dropdown_controller"
application.register("accordion_dropdown", AccordionDropdownController)

import AddressModeController from "./address_mode_controller"
application.register("address-mode", AddressModeController)

import AddressModalController from "./address_modal_controller"
application.register("address-modal", AddressModalController)

import AddressSummaryController from "./address_summary_controller"
application.register("address-summary", AddressSummaryController)

import Admin__AdminLayoutController from "./admin/admin_layout_controller"
application.register("admin--admin-layout", Admin__AdminLayoutController)

import Admin__ArrayManagerController from "./admin/array_manager_controller"
application.register("admin--array-manager", Admin__ArrayManagerController)

import Admin__AuthLayoutController from "./admin/auth_layout_controller"
application.register("admin--auth-layout", Admin__AuthLayoutController)

import Admin__DashboardLayoutController from "./admin/dashboard_layout_controller"
application.register("admin--dashboard-layout", Admin__DashboardLayoutController)

import Admin__DropdownController from "./admin/dropdown_controller"
application.register("admin--dropdown", Admin__DropdownController)

import Admin__FormController from "./admin/form_controller"
application.register("admin--form", Admin__FormController)

import Admin__ClipboardController from "./admin/clipboard_controller"
application.register("admin--clipboard", Admin__ClipboardController)

import Admin__ImageCropperController from "./admin/image_cropper_controller"
application.register("admin--image-cropper", Admin__ImageCropperController)

import Admin__MenuItemFormController from "./admin/menu_item_form_controller"
application.register("admin--menu-item-form", Admin__MenuItemFormController)

import Admin__MenuSorterController from "./admin/menu_sorter_controller"
application.register("admin--menu-sorter", Admin__MenuSorterController)

import Admin__NotificationController from "./admin/notification_controller"
application.register("admin--notification", Admin__NotificationController)

import Admin__PageSorterController from "./admin/page_sorter_controller"
application.register("admin--page-sorter", Admin__PageSorterController)

import Admin__PasswordToggleController from "./admin/password_toggle_controller"
application.register("admin--password-toggle", Admin__PasswordToggleController)

import Admin__PodPreviewController from "./admin/pod_preview_controller"
application.register("admin--pod-preview", Admin__PodPreviewController)

import Admin__CopywritingUrlController from "./admin/copywriting_url_controller"
application.register("admin--copywriting-url", Admin__CopywritingUrlController)

import Admin__PodSorterController from "./admin/pod_sorter_controller"
application.register("admin--pod-sorter", Admin__PodSorterController)

import Admin__MediaUploadController from "./admin/media_upload_controller"
application.register("admin--media-upload", Admin__MediaUploadController)

import Admin__TagAutocompleteController from "./admin/tag_autocomplete_controller"
application.register("admin--tag-autocomplete", Admin__TagAutocompleteController)

import Admin__TinymceController from "./admin/tinymce_controller"
application.register("admin--tinymce", Admin__TinymceController)

import AuthFormToggleController from "./auth_form_toggle_controller"
application.register("auth-form-toggle", AuthFormToggleController)

import CartFormController from "./cart_form_controller"
application.register("cart-form", CartFormController)

import CartProcessingController from "./cart_processing_controller"
application.register("cart-processing", CartProcessingController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import CouponFormController from "./coupon_form_controller"
application.register("coupon-form", CouponFormController)

import FaqsController from "./faqs_controller"
application.register("faqs", FaqsController)

import FilterToggleController from "./filter_toggle_controller"
application.register("filter-toggle", FilterToggleController)

import GoogleAddressController from "./google_address_controller"
application.register("google-address", GoogleAddressController)

import JarallaxController from "./jarallax_controller"
application.register("jarallax", JarallaxController)

import CustomModalController from "./custom_modal_controller"
application.register("custom-modal", CustomModalController)

import DisableOnSubmitController from "./disable_on_submit_controller"
application.register("disable-on-submit", DisableOnSubmitController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import ModalBlockerController from "./modal_blocker_controller"
application.register("modal-blocker", ModalBlockerController)

import OrderReturnController from "./order_return_controller"
application.register("order-return", OrderReturnController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ParrallaxController from "./parrallax_controller"
application.register("parrallax", ParrallaxController)

import PasswordShowController from "./password_show_controller"
application.register("password-show", PasswordShowController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import ProductSearchController from "./product_search_controller"
application.register("product-search", ProductSearchController)

import SizeQuantityController from "./size_quantity_controller"
application.register("size-quantity", SizeQuantityController)

import ContactDetailsController from "./contact_details_controller"
application.register("contact-details", ContactDetailsController)

import PopupController from "./popup_controller"
application.register("popup", PopupController)
